module.exports = require("./kgp.js");